import Swal from "sweetalert2";
import dragula from "dragula";
import {attachNumber} from "../../components/form/number";
import {attachInputMask} from "../../plugins/inputmask";
import {attachMessages} from "../../components/survey/messages";
import {attachRecommendedStatements} from "../../components/survey/recommended-statements";
import {attachCompanyStatements} from "../../components/survey/company-statements";
import {attachCloudFilePopup} from "../../components/cloud/popup";
import {attachCloudFileRemove} from "../../components/cloud/remove";
import {attachCloudFileUpload} from "../../components/cloud/upload";
import sumElementsOnTabs from "./questions/sum-elements-on-tabs";
import getMaxElementsCount from "./questions/get-max-elements-count";
import makeId from "./questions/make-id";
import {attachStatements} from "../../components/survey/statements";
import checkBrandGenderSensitive from "../survey/questions/statements/check-brand-gender-sensitive";
import {attachWarmups} from "../../components/survey/attach-warmups";
import dragDropStatements from "../survey/questions/statements/drag-n-drop-statements";
import attachRotateStatementsSwitch from "../survey/questions/attach-rotate-statements-switch";
import {swalWarningFire} from "../../plugins/sweet-alert/sweet-alert-default";
import getMaxWarmupsCount from "./questions/get-max-warmups-count";
import attachVideoAndSoundTestSwitch from "../../pages/survey/questions/attach-video-and-sound-test-switch";
import attachCloudChangeVideoImage from "../../components/cloud/change-video-image";
import reloadWarmupsCountOnAllParts from "../../components/survey/reload-warmups-count-on-all-parts"
import execute_on from "../../libs/execute-on";
import {attachTooltips} from "./questions/attach-tooltips";
import attachAdvancedSettings from "../../components/survey/attach-advanced-settings";
import {attachFormDirtyToTab, hasFormDirty, isTabDirty, setTabAsClean} from "./questions/attach-form-dirty";
import {attachFroalaEditor} from "../../plugins/froala-editor";
import {attachCloudFileChange} from "../../components/cloud/change";
import {attachConceptNoImage} from "../../components/survey/concept-no-image";
import attachSetVarValueByNameButton from "./questions/attach-set-var-value-by-name-button";

execute_on('survey.questions.edit', function () {
    $(document).on("keydown", "form", function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    });

    function prepareObjectForms($context) {
        const $chosenCategory = $context.find('.object-choose-radio:checked');
        const targetId = $chosenCategory.data('object-target-id');
        const sourceId = $chosenCategory.data('object-source-id');

        const $targetElement = $(document.getElementById(targetId));
        const sourceHtml = $(document.getElementById(sourceId)).html();

        const requestedNumber = parseInt($context.find('.objects-quantity').val(), 10);
        const actualNumber = $targetElement.children().length;

        if(requestedNumber > actualNumber) {
            for (let i = 0; i < (requestedNumber - actualNumber); i++) {
                $targetElement.append(
                    sourceHtml
                        .replaceAll('--OBJECT-ID--', makeId(8))
                        .replaceAll('--CLOUD-OBJECT-ID--', makeId(8))
                );
                setVariableValue($context, actualNumber+i+1);
            }
        }

        if (requestedNumber < actualNumber) {
            $targetElement.children().slice(requestedNumber - actualNumber).remove();
        }

        attachTooltips($context);
    }

    function setVariableValue($context, number) {
        let variableValueNumber = number.toString().padStart(3, '0');
        $context.find('.stimuli-variable-value').last().val(variableValueNumber);
        $context.find('.stimuli-variable-value').last().attr('data-variable-value-number', variableValueNumber);
    }

    function viewWhenIsOnlyOnePart() {
        let tabsLength = $('#nav-tabs-parts .nav-item').length;
        $('.main-tab .alert-remove-part').prop('disabled', tabsLength === 1);
        $('.rotate-parts-switch').toggleClass('hide', tabsLength === 1);
        if(tabsLength === 1) {
            $('.main-tab.active .alert-block-part input').prop('checked', false);
            $('.main-tab.active .alert-block-part').addClass('hide');
            $('#nav-tabs-parts .nav-link.active .padlock').addClass('hide');
        }
    }

    function addElements() {
        const maxSumOfElements = getMaxElementsCount();
        const tabsElementsSum = sumElementsOnTabs();

        //add info how many elements i can use
        if(tabsElementsSum > maxSumOfElements){
            $('.add-new-tab').prop('disabled', true);
            $('.item-count-info')
                .text(`To many questions, please delete ${tabsElementsSum - maxSumOfElements} items`)
                .removeClass('text-warning')
                .removeClass('text-success')
                .addClass('text-danger');
        } else if(tabsElementsSum == maxSumOfElements){
            $('.add-new-tab').prop('disabled', true);
            $('.item-count-info')
                .text(`You create a maximum amount of questions`)
                .removeClass('text-danger')
                .removeClass('text-success')
                .addClass('text-warning');
        } else if (tabsElementsSum < maxSumOfElements) {
            $('.add-new-tab').prop('disabled', false);
            $('.item-count-info')
                .text(`You can still use ${maxSumOfElements - tabsElementsSum} items`)
                .removeClass('text-danger')
                .removeClass('text-warning')
                .addClass('text-success');
        }
    }
    //
    function limitSalesPalObjectsQuantity($selectedRadioButton) {
        const pickSalesPale = $selectedRadioButton.prop('id') === "category-sales-pal";
        if (pickSalesPale) {
            $selectedRadioButton.parents('.main-tab').find(".questions-nr-input input").val(1);
            prepareObjectForms($selectedRadioButton.parents('.main-tab'));
        }
        $selectedRadioButton.parents('.main-tab').find(".questions-nr-input input").prop('readonly', pickSalesPale);
        $(document).ready(function(){$selectedRadioButton.parents('.main-tab').find(".questions-nr-input button").prop('disabled', pickSalesPale);});
        addElements();
    }

    //Parts names after reload
    function renameSurveyParts(){
        let $selectedRadioButton = $(this).find('.category-brand-list-item input:checked');
        let tabId = $(this).prop('id');
        let $navTab = $('.questions-main-nav-tabs .nav-item').find("."+tabId);
        if($selectedRadioButton.length === 0) {
            $navTab.addClass('text-strikethrough');
        } else {
            let selectedType = $selectedRadioButton.parents('.category-brand-list-item').find('.category-name').text();
            let selectedIcon = $selectedRadioButton.parents('.category-brand-list-item').find('.category-icon i').attr('class');
            $navTab.find('.part-name').text(selectedType);
            $navTab.find('.part-icon i').attr('class', selectedIcon);
        }
        //block object quantity in sales pal
        limitSalesPalObjectsQuantity($selectedRadioButton);
    }
    $('#tab-panes-parts').children('.main-tab').each(renameSurveyParts);

    // move tab parts
    dragula([
        document.querySelector('.questions-main-nav-tabs')
    ]).on('drop', function () {
        reloadWarmupsCountOnAllParts();
    });
    
    viewWhenIsOnlyOnePart();
    attachMessages($('.introduction-messages'));
    attachMessages($('.question-message'));
    attachAdvancedSettings();
    $(".main-tab").each(function (index, tab) {
        attachRecommendedStatements($(tab));
        attachCompanyStatements($(tab));
        attachStatements($(tab));
        attachWarmups($(tab));
        dragDropStatements($(tab));
        attachCloudFilePopup($(tab));
        attachCloudFileRemove($(tab));
        attachCloudFileChange($(tab));
        attachCloudFileUpload($(tab));
        attachRotateStatementsSwitch($(tab));
        checkBrandGenderSensitive($(tab));
        attachVideoAndSoundTestSwitch($(tab));
        attachSetVarValueByNameButton($(tab));
        attachCloudChangeVideoImage($(tab));
        attachTooltips($(tab));
        attachConceptNoImage($(tab));

        // Set form as clean with starting data, unchanged
        attachFormDirtyToTab($(tab));

        toggleLottoStimuliCounter($(tab));
    });

    // add part
    $('.add-new-tab').on('click', function (e) {
        e.preventDefault();
        const randomId = makeId(10);
        const tab = $('#questions-tab-template').html().replaceAll('--PART-ID--', randomId);
        const $tabpane = $($('#questions-pane-template').html().replaceAll('--PART-ID--', randomId));

        $('#nav-tabs-parts .nav-tabs').append(tab);
        $('#tab-panes-parts').append($tabpane);

        //setting block part switch visibility
        const isRotatePartChecked = $('#are_question_parts_rotatable').prop('checked');
        $('.alert-block-part').toggleClass('hide', !isRotatePartChecked);

        viewWhenIsOnlyOnePart();
        prepareObjectForms($tabpane);

        attachNumber($tabpane);
        attachInputMask($tabpane);
        attachMessages($tabpane);
        prepareMessages($tabpane);
        attachRecommendedStatements($tabpane);
        attachCompanyStatements($tabpane);
        $('#tab-panes-parts').children('.main-tab').each(renameSurveyParts);
        attachCloudFilePopup($tabpane);
        attachCloudFileRemove($tabpane);
        attachCloudFileChange($tabpane);
        attachCloudFileUpload($tabpane);
        attachStatements($tabpane);
        attachWarmups($tabpane);
        dragDropStatements($tabpane);
        attachRotateStatementsSwitch($tabpane);
        checkBrandGenderSensitive($tabpane);
        attachVideoAndSoundTestSwitch($tabpane);
        attachSetVarValueByNameButton($tabpane);
        attachCloudChangeVideoImage($tabpane);
        attachTooltips($tabpane);
        setDurationRequirementOnConceptTesting();
        setLastTabAsActive();
        attachFroalaEditor();
        attachConceptNoImage($tabpane);

        // Set form as clean with starting data, unchanged
        attachFormDirtyToTab($tabpane);

        toggleLottoStimuliCounter($tabpane);
    });

    function setLastTabAsActive() {
        $(document).find('#nav-tabs-parts li:last-child a').tab('show');
    }

    $('[data-rotate-statements-switch]').on("click", function () {
        const rotateStatementsSwitchVal = $(this).prop('checked');

        if (false === rotateStatementsSwitchVal) {
            Swal.fire({
                title: "Are you sure?",
                text: "Statements will not be rotated",
                icon: "question",
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: '<i class="label-icon bx bx-check"></i> Yes',
                showCancelButton: true,
                cancelButtonText: '<i class="label-icon bx bx-x"></i> No',
                customClass: {
                    confirmButton: 'btn btn-label btn-primary btn-min-width',
                    cancelButton: "btn btn-label btn-danger btn-min-width"
                }
            }).then((result) => {
                if (true !== result.value) {
                    $(this).prop('checked', true);
                } else {
                    const $tabPane = $(this).closest('.tab-pane');
                    $tabPane.trigger('set-statements-lock-icons-visibility', [$(this)]);
                }
            });
        } else {
            const $tabPane = $(this).closest('.tab-pane');
            $tabPane.trigger('set-statements-lock-icons-visibility', [$(this)]);
        }
    });

    $('#are_question_parts_rotatable').on("click", function (e) {
        const isRotatePartChecked = $(this).prop('checked');
        $('.alert-block-part').toggleClass('hide', !isRotatePartChecked);
        if (!isRotatePartChecked) {
            //block part switch off
            const $tabs = $('#tab-panes-parts').children();
            const $navTabs= $('.nav-tabs').children();
            for (let i=0; i < $tabs.length; i++) {
                $($tabs[i]).find('.alert-block-part input').prop('checked', false);
                $($navTabs[i]).find('.padlock').addClass('hide');
            }
        }
        reloadWarmupsCountOnAllParts();
    });

    //Block part switch visibility after reload
    function blockPartSwitchVisibility() {
        const isRotatePartChecked = $('#are_question_parts_rotatable').prop('checked');
        $('.alert-block-part').toggleClass('hide', !isRotatePartChecked);
    }
    blockPartSwitchVisibility();

    function prepareMessages($context) {
        const $chosenCategory = $context.find('.object-choose-radio:checked');
        const introductionMessages = $chosenCategory.data('introduction-messages');
        const questionMessage = $chosenCategory.data('question-message');
        const category = $chosenCategory.val();

        $context.find('.introduction-messages .messages-container')
            .trigger('overwrite-messages', [introductionMessages])
            .trigger('set-restore-category', [category])
        ;
        $context.find('.question-message .message-item')
            .trigger('overwrite-message', questionMessage)
            .trigger('set-restore-category', [category])
        ;
    }

    $('#tab-panes-parts .tab-pane').each(function () {
        prepareObjectForms($(this));
    });

    //renumber brands after reload 
    function renumberAddImageToSurveyObjects(){
        $('.main-tab').each(function(){
            let partCategoryNr= $(this).find('.list-objects').children();
            for (let i=0; i < partCategoryNr.length; i++) {
                $(partCategoryNr[i]).find('.categoryNr p').text(i + 1);
            }
        });
    }
    renumberAddImageToSurveyObjects();

    //visibility gender radiobuttons after reload
    function genderRadioButtonsVisibility(){
        $('.survey-item').each(function(){
            let genderSwitch = $(this).find('.gender-switch input').is(':checked');
            $(this).find('.gender-radio-buttons').toggleClass('hide', !genderSwitch);

            const $tabPane = $(this).closest('.tab-pane');
            $tabPane.trigger('toggle-statements-brand-gender-sensitive', [$tabPane]);
            $tabPane.trigger('toggle-warmups-brand-gender-sensitive', [$tabPane]);
        });
    }
    genderRadioButtonsVisibility();

    function addPicturesToPopup() {
        $('.main-tab .list-objects').each(function(){
            let placeForMaleStatement = $(this).closest('.main-tab').find('.images-container-male');
            let placeForFemaleStatement = $(this).closest('.main-tab').find('.images-container-female');
            placeForFemaleStatement.empty();
            placeForMaleStatement.empty();
            $(this).closest('.main-tab').find('.survey-item-wrapper').each(function(){
                if ( $(this).find('.no-image checkbox').is(':checked') ) {
                    return;
                }
                if ($(this).find('.categoryPic img').length === 0) {
                    return;
                }
                let imageUrl = $(this).find('.categoryPic img').prop('src');
                if ($(this).find('.gender-radio-buttons input:checked').val() === 'female') {
                    placeForFemaleStatement.append('<div class="popup-image"><img src="' + imageUrl + '"></img></div>');
                } else {
                    placeForMaleStatement.append('<div class="popup-image"><img src="' + imageUrl + '"></img></div>');
                }
            });
        });
    }
    addPicturesToPopup();

    function setDurationRequirementOnConceptTesting() {
        $('.brand-item.concept-testing .no-image input:checkbox').on('change', function () {
            $(this).closest('.brand-item').find('.duration input').prop('required', !$(this).is(':checked'));
        });
    }
    setDurationRequirementOnConceptTesting();

    $('#tab-panes-parts')
        .on('change', '.main-tab .list-objects', function(){
            addPicturesToPopup();
        })
        //show popup witch images in click and hover
        .on('click mouseenter mouseleave', '.popup-button', function() {
            $(this).siblings('.popup-for-images').toggleClass('hide');
        })        
        //alert before change survey category
        .on('click', '.main-tab .category-brand-list-item input[type="radio"]', function(e){
            const tab = $(this).closest('.tab-pane');
            if (isTabDirty(tab)) {
                e.preventDefault();
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'Introduced changes will be lost',
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonClass: "btn btn-danger btn-min-width",
                    cancelButtonClass: "btn btn-primary btn-min-width",
                    closeButtonClass: "btn btn-primary btn-min-width"
                }).then((result) => {
                    if (result.value !== true) {
                        return;
                    }
                    $(this).prop('checked', true);
                    $(this).trigger('change');
                });
            }
        })
        .on('change', '.objects-quantity', function () {
            const $context = $(this).parents('.tab-pane');
            prepareObjectForms($context);
            attachWarmups($context);
        })
        .on('change', '.statements-quantity', function () {
            const $context = $(this).parents('.tab-pane');
            attachWarmups($context);
        })
        .on('change', '.object-choose-radio', function () {
            $(document.getElementById($(this).data('object-target-id'))).empty();
            const $pane = $(this).closest('.tab-pane');
            prepareObjectForms($pane);
            prepareMessages($pane);
            attachWarmups($pane);
            attachRecommendedStatements($pane);
            attachCompanyStatements($pane);
            checkBrandGenderSensitive($pane);
            attachVideoAndSoundTestSwitch($pane);
            attachSetVarValueByNameButton($pane);
            setTabAsClean($pane);
        })
        .on('click', '.remove-brand', function () {
            addElements();
        })
        //sumowanie elementów
        .on('change','.questions-nr-input input',  function(e){
            addElements();
        })
        .on('change','.statements-nr-input input',  function(e){
            addElements();
            const $pane = $(this).closest('.tab-pane');
            const value = $(this).val();
            $pane.trigger('establish-statements', [value]);
        })

        // remove part
        .on('click', '.alert-remove-part', function (e) {
            let title = $(this).attr('data-alert-title');
            let text = $(this).attr('data-alert-text');
            let confirmButton = $(this).attr('data-alert-button');

            Swal.fire({
                title: title,
                text: text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: confirmButton,
                confirmButtonClass: "btn btn-danger btn-min-width",
                cancelButtonClass: "btn btn-primary btn-min-width",
                closeButtonClass: "btn btn-primary btn-min-width"
            }).then((result) => {
                if (result.value === true) {
                    $('.nav-link.active').parents('.question-tab-nav-item').remove();
                    $(this).parents('.tab-pane').remove();
                    //add active class to next part
                    $('#nav-tabs-parts .nav-item:first a').trigger('click');
                    viewWhenIsOnlyOnePart();
                    addElements();
                    reloadWarmupsCountOnAllParts();
                }
            });
        })

        // blocking part
        .on('click', '.alert-block-part', function (e) {
            let isSwitchChecked = $('.main-tab.active').find('.alert-block-part').find('.block-part-checkbox').is(':checked');
            $('#nav-tabs-parts .nav-link.active .padlock').toggleClass('hide', !isSwitchChecked);
            reloadWarmupsCountOnAllParts();
        })

        //remove error info from tab part name
        .on('change', ".main-tab.active", function(){
            const tabs = $('#tab-panes-parts').children();
            for (let i=0; i < tabs.length; i++) {
                let actualTabId = $(tabs[i]).attr('id');
                let actualTabNav = $('.'+actualTabId);
                let error = $('#'+actualTabId).find(':invalid').length;
                actualTabNav.find('.error-icon').toggleClass('hide', error === 0);
            }
        })

        //renumber brands
        .on('change', '.objects-quantity', function(){
            $('.main-tab').each(function(){
                let partCategoryNr= $(this).find('.list-objects').children();
                for (let i=0; i < partCategoryNr.length; i++) {
                    $(partCategoryNr[i]).find('.categoryNr p').text(i + 1);
                }
            });
        })

        //add selected brand type
        .on('change', '.main-tab.active', renameSurveyParts)
        .on('change', '.category-brand-list-item', function(){
            attachInputMask($('.dynamic-input-mask'));
            renumberAddImageToSurveyObjects();
        })

        //how many <category> do you want to test?
        .on('change', '.category-brand-list-item', function(){
            const $activeMainTab = $('.main-tab.active');
            const $selectedRadioButton = $activeMainTab.find('.category-brand-list-item input:checked');
            const $mainTabCategoryBrandNumberTextItem = $activeMainTab.find('.category-brand-number-text-item');
            $mainTabCategoryBrandNumberTextItem.text($selectedRadioButton.data('object-prompt'));

            // add help message icon with on end
            const $howManyBrandsHelpMessageIcon = $(document).find('#howManyBrandsHelpMessage').html();
            $mainTabCategoryBrandNumberTextItem.append($howManyBrandsHelpMessageIcon);
            attachTooltips($activeMainTab);
            toggleLottoStimuliCounter($activeMainTab);
        })

        //hide gender if switch gender sensitive is block
        .on('change', '.gender-switch input', function(){
            let genderSwitch = $(this).prop('checked');
            $(this).parents('.survey-item').find('.gender-radio-buttons').toggleClass('hide', !genderSwitch);

            const $tabPane = $(this).closest('.tab-pane');
            $tabPane.trigger('toggle-statements-brand-gender-sensitive', [$tabPane]);
            $tabPane.trigger('toggle-warmups-brand-gender-sensitive', [$tabPane]);
        })

        //add required to gender radiobuttons
        .on('change', '.gender-switch input', function(){
            let isSwitchChecked = $(this).is(':checked');
            $(this).closest('.gender-switch').next('.gender-radio-buttons').find('input').attr('required', isSwitchChecked);
        })
        
        // copy part
        .on('click', '.copy-tab', function (e) {
            const tabpaneSource = $(e.target).parents('.tab-pane.main-tab');
            const pId = $('.part-id-container', tabpaneSource).val();
            const introductionMsgTabsId = $('.introduction-messages .message-tabs .nav-link', $tabpane).first().attr('href').split('-')[1];
            const questionMsgTabsId = $('.question-message .message-tabs .nav-link', $tabpane).first().attr('href').split('-')[1];
            const tabSource = $('#nav-tabs-parts .nav-tabs .part' + pId).removeClass('active').parents('li')[0];
            const randomId = 'pID' + makeId(10);
            const tab = $(tabSource.outerHTML.replaceAll(pId, randomId));
            const $tabpane = $(tabpaneSource.removeClass('active')[0].outerHTML
                    .replaceAll(pId, randomId)
                    .replaceAll(introductionMsgTabsId, '--TABS-ID--')
                    .replaceAll(questionMsgTabsId, '--TABS-ID--'));
            $tabpane.find('[data-warmup-item-image]').each(function(){
                const warmupCloudId = $('.cloud-component-remove', this).first().data('cloud-div-id').split('-')[3];
                $(this).html(
                    $(this).html().replaceAll(warmupCloudId, '--WARMUP-CLOUD-ID--')
                );
            });
            
            $('.copy-tab .waves-ripple', $tabpane).remove();
            $('.padlock', tab).addClass('hide');
            
            $('#nav-tabs-parts .nav-tabs').append(tab);
            $('#tab-panes-parts').append($tabpane);
            
            $tabpane.on('change', '.gender-message-toggle', function () {
                const isChecked = $(this).is(':checked');
                const $mainList = $(this).closest('.message-item');
                $mainList.find('.message-neutral').toggleClass('hide', isChecked);
                $mainList.find('.message-tabs').toggleClass('hide', !isChecked);
            });
    
            //setting block part switch visibility
            const isRotatePartChecked = $('#are_question_parts_rotatable').prop('checked');
            $('.alert-block-part').toggleClass('hide', !isRotatePartChecked);
    
            viewWhenIsOnlyOnePart();
            prepareObjectForms($tabpane);
            
            $('[name="parts['+ randomId +'][id]"]').val('');
            for (const formElem of new FormData($("#survey-new-questions-page")[0]).entries()) {
                if (formElem[0].includes(pId, 6) && !formElem[0].includes('[id]', 6)) {
                    let newElem = $('[name="'+ formElem[0].replace(pId, randomId) +'"]').not('[type="radio"]');
                    newElem.val(formElem[1]);
                    newElem.prop({
                        checked : $('[name="'+ formElem[0] +'"]').last().prop('checked')
                    });
                    $('[name="'+ formElem[0].replace(pId, randomId) +'"][type="radio"][value="'+ formElem[1] +'"]').prop('checked', true);
                }
            }
            $('.alert-block-part input', $tabpane).prop('checked', false).val('off');
            $('.froala-editor', $tabpane).siblings().remove();
    
            attachNumber($tabpane);
            $('button.bootstrap-touchspin-injected', $tabpane).remove();
            attachInputMask($tabpane);
            attachMessages($tabpane);
            attachRecommendedStatements($tabpane);
            attachCompanyStatements($tabpane);
            attachCloudFilePopup($tabpane);
            attachCloudFileRemove($tabpane);
            attachCloudFileChange($tabpane);
            attachCloudFileUpload($tabpane);
            attachStatements($tabpane);
            attachWarmups($tabpane);
            dragDropStatements($tabpane);
            attachRotateStatementsSwitch($tabpane);
            checkBrandGenderSensitive($tabpane);
            attachVideoAndSoundTestSwitch($tabpane);
            attachSetVarValueByNameButton($tabpane);
            attachCloudChangeVideoImage($tabpane);
            attachTooltips($tabpane);
            setDurationRequirementOnConceptTesting();
            setLastTabAsActive();
            attachFroalaEditor();
            attachConceptNoImage($tabpane);
            viewWhenIsOnlyOnePart();
    
            // Set form as clean with starting data, unchanged
            attachFormDirtyToTab($tabpane);

            toggleLottoStimuliCounter($tabpane);
        })
    ;

    $('form').on('submit', function (event) {
        $(".main-tab").each(function (index, tab){
            const maxWarmupCount = getMaxWarmupsCount();
            const warmupCount = $(tab).find('.warmups-list-part .item-position').length;
            const isCategoryRemoved = $(tab).find('.category-removed-handler').length === 1;

            if(isCategoryRemoved) {
                event.preventDefault();
                swalWarningFire({
                    title: 'Category removed',
                    text: 'Delete the part with the removed category before going to the next page'
                });

                // break each loop
                return false;
            }

            // check if any part has too many warps
            if (warmupCount > maxWarmupCount) {
                event.preventDefault();
                swalWarningFire({
                    title: 'Warmup limit',
                    text: 'You have part with over maximum number of warmups. Maximum warmups on part is: '+maxWarmupCount
                });

                // break each loop
                return false;
            }
        });
    });

    const surveyId = $('#survey_id').val();
    const surveyQuestionsActivePartTabStorageItemName = 'surveyQuestionsActivePartTab_' + surveyId;

    // Save survey question active(visible) part tab index
    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
        const tabIndex = $(e.target).parent().index();
        localStorage.setItem(surveyQuestionsActivePartTabStorageItemName, tabIndex);
    });

    // Set tab with errors or last tab active
    setActivePartTab();

    function setActivePartTab() {
        // If there is an error on tab, set this tab as active(visible)
        $(document).find('#nav-tabs-parts li').each(function (index, element) {
            if ($(element).find('.error-icon').not('.hide').length) {
                const tabIndex = $(element).index();
                showPartTab(tabIndex);
                return false;
            }
        });

        // Set last active(visible) survey question part tab or first tab
        const surveyQuestionsActivePartTab = localStorage.getItem(surveyQuestionsActivePartTabStorageItemName) ?? 0;
        showPartTab(surveyQuestionsActivePartTab);
    }

    function showPartTab(tabIndex) {
        $(document).find('#nav-tabs-parts li:eq('+tabIndex+') a').tab('show');
    }

    // if is it lotto then show stimuli per respondent counter
    function toggleLottoStimuliCounter($tab) {
        const $selectedRadioButton = $tab.find('.category-brand-list-item input:checked');
        $($tab.find('.lotto-objects-quantity-row'))
            .toggleClass('hide', !$selectedRadioButton.is('#category-stimuli-flex'));
    }

    attachFroalaEditor();
});
